import { render, staticRenderFns } from "./advertising-icon.vue?vue&type=template&id=4c9b2af8&functional=true&"
import script from "./advertising-icon.vue?vue&type=script&lang=js&"
export * from "./advertising-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports